// Автоимя live-записи: просит локальную модель назвать тему по куску расшифровки.
//
// Работает в фоне после того, как запись уже сохранена в историю, поэтому не бросает
// исключений: любая беда (сеть, отказ модели, таймаут) — это null, и заголовок просто
// остаётся прежним «Запись с микрофона ДД.ММ.ГГ ЧЧ-ММ».
//
// Тот же контур, что и у протокола встречи (MeetingProtocol.js): POST /tasks →
// опрос /tasks/{id}/status → GET /tasks/{id}/result. Переменная сборки уже заведена.
import axios from 'axios';
import { authService } from './authService';
import { ENDPOINTS } from '../config/endpoints';

const API_BASE_URL = ENDPOINTS.summarize;

// Просим ровно имя: модель охотно скатывается в пересказ, а нам нужна одна строка.
const SYSTEM_PROMPT = [
  'Ты придумываешь короткое название встречи по её расшифровке.',
  'Ответь ТОЛЬКО названием: 3-6 слов, по-русски, без кавычек, без точки в конце,',
  'без слов «встреча», «разговор», «запись». Назови суть обсуждения.',
].join(' ');

const POLL_MS = 2000;
const TIMEOUT_MS = 30000;

const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

export const titleService = {
  /**
   * Тема по тексту или null. Никогда не бросает: вызывается из фонового эффекта,
   * где падать некому и незачем.
   */
  async suggestTitle(text, { pollMs = POLL_MS, timeoutMs = TIMEOUT_MS } = {}) {
    if (!text) return null;

    try {
      const headers = authService.getAuthHeaders();
      const { data } = await axios.post(
        `${API_BASE_URL}/tasks`,
        // purpose: 'title' — не тратить пакет саммаризаций тарифа. Автоимя просит
        // фронт сам после каждой live-записи, человек его не заказывал; на
        // «Оплате по факту» (3 протокола в месяц) три записи иначе выносили бы
        // весь пакет.
        { text, system_prompt: SYSTEM_PROMPT, model: 'llama', purpose: 'title' },
        { headers },
      );
      const taskId = data?.task_id;
      if (!taskId) return null;

      const deadline = Date.now() + timeoutMs;
      while (Date.now() < deadline) {
        const status = await axios.get(`${API_BASE_URL}/tasks/${taskId}/status`, { headers });
        const state = status?.data?.status;
        if (state === 'completed') {
          const result = await axios.get(`${API_BASE_URL}/tasks/${taskId}/result`, { headers });
          return result?.data?.summary || null;
        }
        if (state === 'failed') return null;
        await sleep(pollMs);
      }
      return null;                       // задача висит — уходим, имя-дата остаётся
    } catch {
      return null;
    }
  },
};
